import { Component, OnInit } from '@angular/core';
import { ConfirmState } from 'src/app/shared/dialogs/models/ConfirmState';
import { MsgOptions } from 'src/app/shared/dialogs/models/MsgOptions';

@Component({
  selector: 'app-confirm-public-modal',
  templateUrl: './confirm-public-modal.component.html',
  styleUrls: ['./confirm-public-modal.component.scss']
})
export class ConfirmPublicModalComponent implements OnInit {
  options: MsgOptions;
  labelno: string;
  labelyes: string;

  constructor(private state: ConfirmState) {
    this.options = state.options;
    this.labelno = state.labelno;
    this.labelyes = state.labelyes;
  }


  ngOnInit(): void {
  }

  yes() {
    this.state.modal.close('confirmed');
  }

  no() {
    this.state.modal.dismiss('not confirmed');
  }
}
